import { Outlet } from "react-router-dom";

const OrdersPage = () => <Outlet />;

export default OrdersPage;
